import { Fragment } from 'react';

import { Flex, Table } from '@zillow/constellation';

import { AppSelectors } from '../../../selectors';
import { useSelector } from '../../../selectors/useSelector';

import Bone from '../../../components/Bone';

// styled components
import { StyledPropertyAddress, StyledPropertyRow } from '../../../components/soh/PropertyRow/StyledComponents';

import { StyledPropertyRowSkeletonPhotoContainer } from './StyledComponents';

const PropertyRowSkeleton = () => {
  const isEnterpriseCustomer = useSelector((state) => state.user.isEnterpriseCustomer);
  const isScreenMobile = useSelector((state) => AppSelectors.makeIsScreenMobile(state));
  const isScreenLgGTE = useSelector((state) => AppSelectors.makeIsScreenLgGTE(state));
  const isScreenXlGTE = useSelector((state) => AppSelectors.makeIsScreenXlGTE(state));

  const show3D = !isEnterpriseCustomer || isScreenXlGTE;

  return (
    <StyledPropertyRow>
      <Table.Cell>
        <StyledPropertyRowSkeletonPhotoContainer>
          <Bone type="bar" cover={true} dark={true} />
        </StyledPropertyRowSkeletonPhotoContainer>
      </Table.Cell>
      {isScreenLgGTE && (
        <Fragment>
          <Table.Cell>
            <Bone type="line" dark={true} />
            <StyledPropertyAddress marginTop={true}>
              <Flex flex="1">
                <Bone type="line" dark={true} />
              </Flex>
              <div>
                <Bone type="line" dark={true} />
              </div>
              <div>
                <Bone type="line" dark={true} />
              </div>
            </StyledPropertyAddress>
          </Table.Cell>
          {show3D && (
            <Fragment>
              <Table.Cell>
                <Bone type="line" dark={true} />
              </Table.Cell>
            </Fragment>
          )}
          <Table.Cell>
            <Bone type="line" dark={true} />
          </Table.Cell>
          <Table.Cell>
            <Bone type="line" dark={true} />
          </Table.Cell>
        </Fragment>
      )}
      {isEnterpriseCustomer && (
        <Fragment>
          {!isScreenMobile && (
            <Table.Cell>
              <Bone type="line" dark={true} />
            </Table.Cell>
          )}
          <Table.Cell>
            <Bone type="line" dark={true} />
          </Table.Cell>
        </Fragment>
      )}
    </StyledPropertyRow>
  );
};

export default PropertyRowSkeleton;
